document.addEventListener('DOMContentLoaded', function() {
  const noteField = document.getElementById('note');
  const counter = document.createElement('div');
  counter.id = 'cart-note-counter';
  counter.style.fontSize = '12px';
  counter.style.marginTop = '5px';

  if (noteField) {
    noteField.parentNode.appendChild(counter);

    const updateCounter = () => {
      const remaining = 100 - noteField.value.length;
      counter.textContent = `Characters remaining: ${remaining}`;
    };

    noteField.addEventListener('input', updateCounter);
    updateCounter(); // Initial call to set the counter
  }
});